import React from "react"

import globalStyles from "../../../../App.module.scss";
import expiry from './images/expiry.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function SslExpiryChecker() {

    let data = `import socket
import ssl
import sys
from datetime import datetime, timezone


def get_cert_expiry(hostname, port=443, timeout=5):
    context = ssl.create_default_context()
    with socket.create_connection((hostname, port), timeout=timeout) as sock:
        with context.wrap_socket(sock, server_hostname=hostname) as ssock:
            cert = ssock.getpeercert()
    expires_at = datetime.strptime(cert["notAfter"], "%b %d %H:%M:%S %Y %Z")
    return expires_at.replace(tzinfo=timezone.utc)


def main():
    domains = sys.argv[1:]
    if not domains:
        print("Usage: python ssl_expiry_checker.py domain1 [domain2 ...]")
        sys.exit(1)

    for domain in domains:
        try:
            expires_at = get_cert_expiry(domain)
            days_left = (expires_at - datetime.now(timezone.utc)).days
            flag = "  [renew soon]" if days_left < 30 else ""
            print(f"{domain}: expires {expires_at.date()} ({days_left} days left){flag}")
        except Exception as err:
            print(f"{domain}: error - {err}")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>SSL certificate expiry checker</h1>
            <p>Opens a TLS connection to each domain given on the command line, reads back the server's
                certificate, and reports how many days remain before it expires — flagging anything under 30
                days. Handy to run against a list of domains you manage before a renewal catches you by surprise.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>The program above produces the next output:</p>
            <div style={{maxWidth: '800px'}}>
                <img src={expiry} alt={""}/>
            </div>
        </div>
    )
}
